// ======================================================================
// File Name       : ImportContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Col } from 'react-bootstrap';
import BatchImport from '../components/BatchImport';
import BatchHistory from '../components/BatchHistory';
import { MESSAGE_TIME_OUT, RETURN_MAX_NUM, MESSAGE_TYPE, ROOT_URL, SLASH_SEPARATOR, DOT_SAPERATOR, NEW_COURSE_MANAGEMENT_URL, COURSE_LAYOUT_TYPE } from '../constants/index';
import { getEditListResult, importEditListFile } from '../actions/ImportAction';
import { CONTENT, USER, COURSE } from '../constants/PathConstants';
import * as ImportUtils from '../utils/ImportUtils';
import { downLoadImportFile } from '../utils/ApiUtils';
import Header from '../components/Header';
import { handleDownload } from '../utils/index';
import * as FUNCTION from '../constants/FunctionConstants';
import * as Path from '../constants/PathConstants';
import CustomLink from '../components/button/CustomLink';

class ImportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileUpload: null,
      fileName: '',
    };
    this.getEditListResult = this.getEditListResult.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.handlePageSelect = this.handlePageSelect.bind(this);
    this.resultParam = {
      importSortType: null,
      ascendingDescendingSort: null,
      startPosition: 0,
    };
    this.pathOptions = {
      importPath: '',
      getListPath: '',
      importDrillServer: false,
      getListDrillServer: false,
      returnListPath: '',
      returnListTitle: '',
      isShowNote: false, // Step 11.0.0
    };
    this.redirectToNewCourseLayout = this.redirectToNewCourseLayout.bind(this);
  }

  componentWillMount() {
    const path = ImportUtils.getAction(this.props.match.url);
    this.pathOptions = {
      ...this.pathOptions,
      importPath: path.importPath,
      getListPath: path.getListPath,
      importDrillServer: path.importDrillServer,
      getListDrillServer: path.getListDrillServer,
      title: path.title,
      enterpriseId: path.enterpriseId,
      csvSamplePath: path.csvSamplePath,
      titleDistribution: path.titleDistribution,
      returnListPath: path.returnListPath,
      returnListTitle: path.returnListTitle,
      isShowNote: path.isShowNote, // Step 11.0.0
    };
    this.getEditListResult();
  }

  handleFileChange(event) {
    if (event.target.files.length !== 0) {
      const fileName = event.target.files[0].name;
      this.setState({
        fileUpload: event.target.files[0],
        fileName,
      });
    }
  }

  handleUpload() {
    const { dispatch } = this.props;
    dispatch(
      importEditListFile(this.state.fileUpload, this.resultParam, this.pathOptions),
    );
  }

  handleDownload(url, fileName) {
    return handleDownload(url, fileName);
  }

  handleSortState({ sortBy, sortState }) {
    this.resultParam = {
      importSortType: sortBy,
      ascendingDescendingSort: sortState,
      startPosition: 0,
    };
    this.getEditListResult();
  }

  handlePageSelect(startPosition) {
    this.resultParam = { ...this.resultParam, startPosition };
    this.getEditListResult();
  }

  getEditListResult() {
    const { dispatch } = this.props;
    dispatch(getEditListResult(this.resultParam, this.pathOptions));
  }

  // Step 11.0.0 START
  redirectToNewCourseLayout() {
    window.location.href = NEW_COURSE_MANAGEMENT_URL;
  }
  // Step 11.0.0 END

  render() {
    const { importList } = this.props;
    // #6367 START
    const { url } = this.props.match;
    const sampleFileName = this.pathOptions.csvSamplePath.split(SLASH_SEPARATOR).pop();
    const downloadSampleFile = [sampleFileName];
    // #6367 END
    const title = this.pathOptions.title ?
      `${this.pathOptions.title}のCSV投入・一括処理一覧` :
      `${this.pathOptions.titleDistribution}のCSV投入・一括処理一覧`;
    // Step 11.0.0 START
    let isRedirectNewCourseLayout = false;
    if (
      url === Path.COURSE_IMPORT &&
      localStorage.getItem('courseLayoutType') === COURSE_LAYOUT_TYPE.NEW
    ) {
      isRedirectNewCourseLayout = true;
    }
    const customLink = (
      isRedirectNewCourseLayout ? (
        <CustomLink
          className="margin-right-7 url-list"
          text={this.pathOptions.returnListTitle}
          icon="bi bi-chevron-left"
          onClick={this.redirectToNewCourseLayout}
        />
      ) : (
        <CustomLink
          className="margin-right-7 url-list"
          to={this.pathOptions.returnListPath}
          text={this.pathOptions.returnListTitle}
          icon="bi bi-chevron-left"
        />
      )
      // Step 11.0.0 END
    );
    return (
      <Col className="padding-left-15 padding-right-15">
        {customLink}
        <Header name={title} />
        <Form className='form-horizontal' onSubmit={(e) => { e.preventDefault(); }}>
          <p className="margin-top-10">一括で投入する{this.pathOptions.title}のファイルを指定してください</p>
          {/* Step 11.0.0 START */}
          {this.pathOptions.isShowNote && (
            <>
              <p className="margin-top-10 textColorRed">2024年12月5日よりCSVフォーマットが変更になりました。</p>
              <p className="margin-top-10 textColorRed">以前よりご利用のCSVは入稿できなくなりますので、下記よりサンプルダウンロードをしていただいたCSVにて入稿してください。</p>
            </>
          )}
          {/* Step 11.0.0 END */}
          <BatchImport
            downloadSampleFile={downloadSampleFile}
            handleFileChange={this.handleFileChange}
            fileName={this.state.fileName}
            handleUpload={this.handleUpload}
          />
          <BatchHistory
            resultInfo={importList.result}
            renderData={this.getEditListResult}
            handleSortState={this.handleSortState}
            handlePageSelect={this.handlePageSelect}
            startPosition={this.resultParam.startPosition}
            onClickDownload={this.handleDownload.bind(this)}
            dataSort={this.resultParam}
          />
        </Form>
      </Col>
    );
  }
}

ImportContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
  importList: PropTypes.shape().isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { importList } = state;
  return { importList };
};
export default connect(mapStateToProps)(ImportContainer);
